<template>
  <div class="edit-notification">
    <mdb-card>
      <mdb-card-header class="pt-4 indigo">
        <mdb-card-title class="text-white"
          ><strong>{{ $t("notification_extra") }}</strong></mdb-card-title
        >
      </mdb-card-header>
      <mdb-card-body v-if="this.loadReady === true">
        <mdb-row>
          <mdb-col md="6">
            <p class="h5">{{ $t("notification_extra_content") }}</p>
          </mdb-col>
        </mdb-row>
        <mdb-row>
          <mdb-col>
            <mdb-input
              v-model="title"
              v-if="this.loadReady === true"
              type="text"
              icon="quote-right"
              :label="$t('notification_extra_title')"
            />
          </mdb-col>
          <mdb-col md="6">
            <Categories
              v-on:categories="selectedCategories"
              v-if="
                this.loadReady === true && notificationtypeiscategory === true
              "
              :multipleSelected="false"
              :category-id="categoryId"
            />
          </mdb-col>
        </mdb-row>
        <mdb-row>
          <mdb-col>
            <DateTimePicker
              v-on:datetime-changed="dateTimeChanged"
              v-if="dateTime.length > 0 && notificationtypeiscategory === true"
              :date-time="dateTime"
              :title="$t('notification_extra_datepicker_title')"
            />
          </mdb-col>
          <mdb-col>
            <NotificationGrouping
              v-on:groups="selectedGroups"
              :notificationGroupsId="groups"
              v-if="
                this.loadReady === true && notificationtypeiscategory === true
              "
            />
          </mdb-col>
        </mdb-row>
        <mdb-row>
          <mdb-col>
            <hr />
            <p class="h6">{{ $t("notification_extra_image") }}</p>
            <ImageInput
              :image-src="image"
              :imageWidth="400"
              :buttonName="$t('notification_add_image')"
              v-on:general-image="imageChanged"
            />
            <hr />
          </mdb-col>
        </mdb-row>
        <mdb-row>
          <mdb-col>
            <mdb-btn
              @click="savenotification"
              color="indigo"
              class="white-text"
              icon="paper-plane"
              >{{ $t("save") }}
            </mdb-btn>
          </mdb-col>
        </mdb-row>
      </mdb-card-body>
    </mdb-card>
  </div>
</template>

<script>
import {
  mdbRow,
  mdbCol,
  mdbInput,
  mdbBtn,
  mdbCard,
  mdbCardBody,
  mdbCardHeader,
  mdbCardTitle,
} from "mdbvue";
import Categories from "./Categories.vue";
import DateTimePicker from "./DateTimePicker.vue";
import NotificationGrouping from "./NotificationGrouping.vue";
import moment from "moment";
import ImageInput from "./ImageInput.vue";

export default {
  name: "Editnotificationextra",
  components: {
    mdbRow,
    mdbCol,
    mdbInput,
    mdbBtn,
    mdbCard,
    mdbCardBody,
    mdbCardHeader,
    mdbCardTitle,
    ImageInput,
    Categories,
    DateTimePicker,
    NotificationGrouping,
  },
  props: {
    notificationType: String,
    unionmemberid: {
      type: String,
      default: "",
    },
    defaultMarker: Object,
  },
  methods: {
    defaultDateTime() {
      var m = moment().add(7, "days");
      m.set({ hour: 12, minute: 0, second: 0, millisecond: 0 });
      return m.format("YYYY-MM-DD HH:mm");
    },
    defaultNowDateTime() {
      var m = moment();
      return m.format("YYYY-MM-DD HH:mm");
    },
    setUnionMemberId(val) {
      this.localUnionMemberId = val;
    },
    loadnotification() {
      if (!this.isNewnotification()) {
        this.getnotification(this.getnotificationId());
      } else {
        this.loadReady = true;
      }
    },
    getnotificationId() {
      try {
        return parseInt(this.$route.path.match(/(\d+)/)[0]);
      } catch (error) {
        console.log(error);
        return 0;
      }
    },
    isNewnotification() {
      return this.getnotificationId() === 0;
    },
    member(member) {
      if (member === undefined) return;
      this.retailer = member;
      if (this.notificationFromBackend === false) {
        this.marker.position.lat = Number(member.lat);
        this.marker.position.lng = Number(member.lng);
        this.createMarker();
      }
      this.notificationFromBackend = false;
    },
    dateTimeChanged(val) {
      if (this.dateTime.localeCompare(val) !== 0) {
        this.dateTime = val;
      }
    },
    selectedGroups(value, text) {
      this.groups = value.toString();
      console.log(value, text);
    },
    selectedCategories(value, text) {
      this.category_id = value;
      console.log(value, text);
    },
    getnotification(id) {
      this.$notify.info({
        message: this.$t("loading_notification_extra"),
        position: "top right",
        timeOut: this.$store.state.notifytimeoutmedium,
      });
      this.$http
        .get(this.notificationextrapath + "/" + id)
        .then((response) => {
          if (response.status == 200) {
            this.notificationextra = response.data.notificationextra[0];
            setTimeout(() => this.fillPage(), 2000);
          } else if (response.status == 401) {
            this.$root.$emit("session_failed");
          }
        })
        .catch((error) => {
          return error;
        });
    },
    getnotificationuniquetype() {
      this.$notify.info({
        message: this.$t("loading_notification_extra"),
        position: "top right",
        timeOut: this.$store.state.notifytimeoutmedium,
      });
      this.$http
        .get(this.notificationextrapath)
        .then((response) => {
          if (response.status == 200) {
            this.notificationextra = response.data.notificationextra[0];
            setTimeout(() => this.fillPage(), 2000);
          } else if (response.status == 401) {
            this.$root.$emit("session_failed");
          }
        })
        .catch((error) => {
          return error;
        });
    },
    fillPage() {
      if (this.notificationtypeiscategory) {
        this.dateTime = this.notificationextra.due;
        this.categoryId = this.category_id = parseInt(
          this.notificationextra.category_id
        );
        this.title = this.notificationextra.title;
        this.groups = this.notificationextra.groups;
        this.image = this.notificationextra.image;
      } else {
        this.title = this.notificationextra.title;
        this.image = this.notificationextra.image;
      }
      this.loadReady = true;
    },
    savenotification() {
      if (this.notificationtypeiscategory) {
        this.postData = {
          id: this.getnotificationId(),
          sessionid: this.$store.getters.getToken,
          groups: this.groups,
          title: this.title,
          category_id: this.category_id,
          due: this.dateTime,
          image: this.image,
        };
      } else {
        this.postData = {
          title: this.title,
          image: this.image,
        };
      }
      console.log(this.postData);
      this.$http
        .post(this.notificationextrapath, JSON.stringify(this.postData))
        .then((response) => {
          if (response.status == 200) {
            this.$notify.success({
              message: this.$t("adding_notification_extra_success"),
              position: "top right",
              timeOut: this.$store.state.notifytimeoutshort,
            });
          }
          this.$emit("modal-ok");
          if (this.notificationType == "NOTIFICATION_CATEGORY") {
            this.$router.push("/notificationsextra");
          }
        })
        .catch((error) => {
          this.$notify.error({
            message: this.$t("adding_notification_extra_not_success"),
            position: "top right",
            timeOut: this.$store.state.notifytimeoutshort,
          });
          this.$emit("modal-ok");
          console.log(error);
        })
        .finally(() => (this.loading = false));
    },
    imageChanged(image) {
      this.image = image;
    },
  },
  mounted() {
    switch (this.notificationType) {
      case "UNREGISTERED_ACTIVATION":
        this.notificationtypeiscategory = false;
        this.notificationextrapath =
          "/1.0/front/notificationsextra?type=NOTIFICATION_UNREGISTERED_ACTIVATION";
        this.getnotificationuniquetype();
        break;
      case "REGISTERED_ACTIVATION":
        this.notificationtypeiscategory = false;
        this.notificationextrapath =
          "/1.0/front/notificationsextra?type=NOTIFICATION_REGISTERED_ACTIVATION";
        this.getnotificationuniquetype();
        break;
      case "PASSIVED_REGISTERED_ACTIVATION":
        this.notificationtypeiscategory = false;
        this.notificationextrapath =
          "/1.0/front/notificationsextra?type=NOTIFICATION_PASSIVED_REGISTERED_ACTIVATION";
        this.getnotificationuniquetype();
        break;
      default:
        this.notificationextrapath =
          "/1.0/front/notificationsextra";
        this.loadnotification();
        break;
    }
  },
  data() {
    return {
      notificationextrapath: "/1.0/front/notificationextra",
      notificationtypeiscategory: true,
      notificationextra: null,
      notificationFromBackend: false,
      localUnionMemberId: this.unionmemberid,
      advertisementid: null,
      retailer: null,
      title: "",
      dateTime: this.defaultDateTime(),
      formattedDateTime: "",
      category_id: null,
      groups: "",
      categoryId: 0,
      marker: this.defaultMarker,
      loadReady: false,
      image: "https://mdbootstrap.com/img/Photos/Others/placeholder.jpg",
    };
  },
};
</script>
